import { NEXT_PUBLIC_API_URL } from "@/config/env";

export const couponsApiCalls = {
  companyInfo: (companyslug: string) => `${NEXT_PUBLIC_API_URL}/api/v4/redeemable-business/${companyslug}/info/`,
  students: (companySlug: string) =>
    `${NEXT_PUBLIC_API_URL}/api/v4/redeemable-business/${companySlug}/users/?page_size=20`,
  studentsByPage: (companySlug: string, page: number) =>
    `${NEXT_PUBLIC_API_URL}/api/v4/redeemable-business/${companySlug}/users/?page_size=20&page=${page}`,
  filteredStudents: (companySlug: string, queryParams: string, page: number) =>
    `${NEXT_PUBLIC_API_URL}/api/v4/redeemable-business/${companySlug}/users/?${queryParams}&page=${page}&page_size=20`,
  generateReport: (companySlug: string) => `${NEXT_PUBLIC_API_URL}/api/v4/redeemable-business/${companySlug}/report/`,
};
